import { render } from "./SettingDashboard.vue?vue&type=template&id=3dbb9196&scoped=true"
import script from "@/assets/js/dashboard.js?vue&type=script&lang=js&external"
export * from "@/assets/js/dashboard.js?vue&type=script&lang=js&external"

import "@/assets/css/dashboard.css?vue&type=style&index=0&id=3dbb9196&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbb9196"]])

export default __exports__